import type { CartUI } from '@libs/common-node';

import { DeliveryType, Nullable } from '../../../core/src';
import { isProductRxMedColdItem } from './productVetRxColdItem';

export const hasFulfillmentMethodInCart = (cart: Nullable<CartUI>, deliveryType: DeliveryType) =>
    cart?.fulfillmentGroups?.some(group => group.fulfillmentMethod.toLowerCase() === deliveryType.toLowerCase());

export const hasBopisInCart = (cart: Maybe<CartUI>) =>
    cart?.fulfillmentGroups?.some(group => group.fulfillmentMethod.toLowerCase() === DeliveryType.BOPIS) || false;

export const hasSTHInCart = (cart: Maybe<CartUI>) =>
    cart?.fulfillmentGroups?.some(group => group.fulfillmentMethod.toLowerCase() === DeliveryType.STH) || false;

export const hasSDDInCart = (cart: Maybe<CartUI>) =>
    cart?.fulfillmentGroups?.some(group => group.fulfillmentMethod.toLowerCase() === DeliveryType.SDD) || false;

/** True when any line item is flagged as US or CA dropship (BFF line-item fields). */
export const hasDropshipLineItemInCart = (cart: Maybe<CartUI>) =>
    cart?.fulfillmentGroups?.some(group =>
        group.items?.some(item => item.isDropshipUS === true || item.isDropshipCA === true)
    ) || false;

export const hasColdRxInCart = (cart: Maybe<CartUI>) =>
    cart?.fulfillmentGroups?.some(group => group.items?.some(item => isProductRxMedColdItem(item))) || false;

export const hasAutoshipInCart = (cart: Maybe<CartUI>) =>
    cart?.fulfillmentGroups?.some(
        group =>
            group.fulfillmentMethod.toLowerCase() === DeliveryType.AUTOSHIP ||
            group.items?.some(item => item?.autoshipFrequency && item?.autoshipFrequencyUnitOfMeasure)
    ) || false;

/** True when at least one line item is a one-time (non-Autoship) purchase. */
export const hasNonAutoshipItemInCart = (cart: Maybe<CartUI>) =>
    cart?.fulfillmentGroups?.some(
        group =>
            group.fulfillmentMethod.toLowerCase() !== DeliveryType.AUTOSHIP &&
            group.items?.some(item => !(item?.autoshipFrequency && item?.autoshipFrequencyUnitOfMeasure))
    ) || false;

/** True only when the cart has both Autoship and one-time items (WBBT-316 AC3 vs. AC2). */
export const hasMixedAutoshipCart = (cart: Maybe<CartUI>) => hasAutoshipInCart(cart) && hasNonAutoshipItemInCart(cart);

export const hasOnlyDeliveryType = (cart: Maybe<CartUI>, deliveryType: DeliveryType) =>
    cart?.fulfillmentGroups?.every(group => group.fulfillmentMethod.toLowerCase() === deliveryType.toLowerCase());
